import React, { Component } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import Divider from '@ui/Divider'
import Section from '@ui/Section'

class LastStep extends Component {
  render() {
    const {
      editButton,
      submitButton,
      onEdit,
      onSubmit,
      submitting,
      title,
      description
    } = this.props

    return (
      <div className='custom-container flex vertical survey-confirmation'>
        <Icon name='send' className='survey-confirmation-icon' size='huge' />
        <Section size='h1' title={title} description={description} />
        <Divider hidden />
        <div className='custom-actions button-actions flex no-wrap vertical'>
          <Button
            onClick={onSubmit}
            size='big'
            className='survey-button primary survey-confirmation-submit'
            disabled={submitting}
            loading={submitting}
          >
            {submitButton}
          </Button>
          <Button
            onClick={onEdit}
            size='big'
            className='survey-button basic small survey-confirmation-edit'
          >
            <Button.Content visible>{editButton}</Button.Content>
          </Button>
        </div>
      </div>
    )
  }
}

export default LastStep
